<div class="container-vehicle vehicle-tacho__stats">
    <div class="container-vehicle__wrapper">
        <div class="container-vehicle__wrapper__item stat stat-0" [ngClass]="{'stat-active' : slotData.CurrentState === 0}">
            <span class="stat-icon stat-icon-0"></span>
            <span class="title">
                {{ (slotData?.StatValue1 / 1) | hoursTimeFormat }}
            </span>
        </div>
        <div class="container-vehicle__wrapper__item stat stat-1" [ngClass]="{'stat-active' : slotData.CurrentState === 1}">
            <span class="stat-icon stat-icon-1"></span>
            <span class="title">
                {{ (slotData?.StatValue2/ 1) | hoursTimeFormat }}
            </span>
        </div>
        <div class="container-vehicle__wrapper__item stat stat-2" [ngClass]="{'stat-active' : slotData.CurrentState === 2}">
            <span class="stat-icon stat-icon-2"></span>
            <span class="title">
                {{ (slotData?.StatValue3/ 1) | hoursTimeFormat }}
            </span>
        </div>
        <div class="container-vehicle__wrapper__item stat stat-3" [ngClass]="{'stat-active' : slotData.CurrentState === 3}">
            <span class="stat-icon stat-icon-3"></span>
            <span class="title">
                {{ (slotData?.StatValue4/ 1) | hoursTimeFormat }}
            </span>
        </div>
    </div>
</div>
